export enum RootRuntimeVariant {
    Full = 'full',
    PublicLogin = 'public_login',
    PublicShare = 'public_share',
}
